import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Button } from "@whoosh/design-system/src/components/controls";
import { VStack } from "@whoosh/design-system/src/components/primitive";

import { useJoinBooking } from "../../hooks/useJoinBooking/useJoinBooking";
import { ActionButton_Booking$key } from "./__generated__/ActionButton_Booking.graphql";

export const ActionButton = ({
  bookingRef,
}: {
  bookingRef: ActionButton_Booking$key | null;
}) => {
  const booking = useFragment(ActionButtonFragmentString, bookingRef);
  const { handleJoinBooking, isJoining } = useJoinBooking({
    bookingRef: booking ?? null,
  });
  return (
    <VStack padding={5} borderTopWidth={1.5} borderColor="outline-default">
      <Button
        accessibilityLabel={t`Finish and Join`}
        isDisabled={isJoining}
        onPress={() => {
          handleJoinBooking();
        }}
      >
        {t`Finish and Join`}
      </Button>
    </VStack>
  );
};

const ActionButtonFragmentString = graphql`
  fragment ActionButton_Booking on Booking {
    ...useJoinBooking_Booking
  }
`;
